import {toggleFormat} from '@wordpress/rich-text';
import {RichTextToolbarButton} from '@wordpress/block-editor';
import {canNestTag} from "./utils";

export const JuZRichTextExtenderCustomButton = ({isActive, onChange, value, format}) => {
    const tagName = format.tagName || 'span';
    const isSpan = tagName === 'span';

    // canNestTag is only relevant for non-span tags
    let isDisabled = false;
    if (!isSpan) {
        const activeFormats = value.activeFormats || [];
        const activeTags = activeFormats
            .filter(f => f.tagName)
            .map(f => f.tagName);

        const innerTags = (value.formats || [])
            .flat()
            .filter(f => f && f.tagName && !activeFormats.includes(f))
            .map(f => f.tagName)
            .filter((tag, index, self) => self.indexOf(tag) === index);

        const canNest = canNestTag(activeTags, tagName, innerTags);
        isDisabled = !canNest && !isActive;
    }

    return (
        <RichTextToolbarButton
            icon={format.icon}
            title={format.title}
            isDisabled={isDisabled}
            isActive={isActive}
            onClick={() => {
                if (isDisabled) return;
                onChange(toggleFormat(value, {type: `juz-rich-text-extender/${format.name}`}));
            }}
        />
    );
};
